import Pill from '@components/V3/Pill'

export default function CartDeliverySkeleton() {
  return <Pill showCaret={false} className="h-full w-full bg-gray-100 animate-pulse"></Pill>
}
